import NotFound from 'components/NotFound';
import CheckinComplete from 'components/Patient/checkin/CheckinComplete';
import CheckinSteps from 'components/Patient/checkin/CheckinSteps';
import PatientCheckinEditingSelector from 'components/Patient/checkin/EditingSelector';
import PatientCheckinLogin from 'components/Patient/checkin/Login';
import PastForms from 'components/Patient/checkin/PastForms/PastForms';
import PersonalID from 'components/Patient/checkin/PersonalId/PersonalId';
import PersonalInformationContainer from 'components/Patient/checkin/PersonalInfo/PersonalInfo';
import ReturnCheck from 'components/Patient/checkin/ReturnCheck';
import Review from 'components/Patient/checkin/Review/Review';
import CheckinForms from 'components/Patient/checkin/checkin_forms';
import HipaaFormContainer from 'components/Patient/checkin/hipaa_form_container';
import Insurance from 'components/Patient/checkin/insurance';
import Payment from 'components/Patient/checkin/payment';
import PayPrompt from 'components/Patient/checkin/payment/payPrompt';
import PaySuccess from 'components/Patient/checkin/payment/paySuccess';
import PreAuth from 'components/Patient/checkin/payment/preAuth';

const CHECK_IN = [
  {
    path: 'checkin',
    element: <CheckinSteps />,
    children: [
      { path: 'choices', element: <PatientCheckinEditingSelector /> },
      {
        path: 'personal-info',
        element: <PersonalInformationContainer />
      },
      {
        path: 'form/:id',
        element: <CheckinForms />
      },
      {
        path: 'hipaa',
        element: <HipaaFormContainer />
      },
      {
        path: 'personal-id',
        element: <PersonalID />
      },
      {
        path: 'insurance',
        element: <Insurance />
      },
      {
        path: 'login',
        element: <PatientCheckinLogin isCheckin={true} />
      },
      {
        path: 'payment',
        element: <Payment />
      },
      {
        path: 'pre-auth',
        element: <PreAuth />
      },
      {
        path: 'pay',
        element: <PayPrompt />
      },
      {
        path: 'pay-success',
        element: <PaySuccess />
      },
      {
        path: 'complete',
        element: <CheckinComplete />
      },
      {
        path: 'review',
        element: <Review />
      },
      {
        path: 'past',
        element: <PastForms />
      },
      {
        path: 'return-check',
        element: <ReturnCheck />
      },
      {
        path: '*',
        element: <NotFound portal="checkin" />
      }
    ]
  }
];
export default CHECK_IN;
